/** Formats phone with DDI prefix (e.g. +55 11 99999-9999). */
export const formatClientPhoneWithDdi = (
  countryCode: string,
  phoneNumber: string
): string => {
  const ddi = (countryCode || "55").replace(/\D/g, "");
  const digits = phoneNumber.replace(/\D/g, "");

  if (!digits) {
    return `+${ddi}`;
  }

  if (ddi === "55") {
    if (digits.length >= 11) {
      return `+55 ${digits.slice(0, 2)} ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
    }

    if (digits.length >= 10) {
      return `+55 ${digits.slice(0, 2)} ${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
    }

    return `+55 ${digits}`;
  }

  return `+${ddi} ${digits}`;
};

/** Name + DDI phone label for pickers (e.g. "Maria · +55 11 99999-9999"). */
export const formatClientPickerLabel = (
  name: string,
  countryCode: string,
  phoneNumber: string
): string => `${name} · ${formatClientPhoneWithDdi(countryCode, phoneNumber)}`;
